import {createApp} from "vue";
import {createWebHistory, createRouter} from "vue-router";
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'bootstrap-icons/font/bootstrap-icons.css'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import axios from "axios";

// styles

import "@fortawesome/fontawesome-free/css/all.min.css";
import "@/assets/styles/tailwind.css";



import App from "@/App.vue";


// views for Auth layout

import Login from "@/views/auth/Login.vue";
import Download from "@/views/Download.vue";

// views without layouts


import Index from "@/views/Index.vue";
import singlecelldetail from "@/views/singlecell_detail.vue";
import singlecellinfo from "@/views/singlecell_info.vue";
import tutorial from "@/views/Tutorial.vue";
// routes

const routes = [
    {
        path: "/tutorial",
        name: "tutorial",
        component: tutorial,
    },
    {
        path: "/singlecelldetail",
        name: "singlecelldetail",
        component: singlecelldetail,
    },
    {
        path: "/singlecellinfo",
        name: "singlecellinfo",
        component: singlecellinfo,
    },
    {
        path: "/",
        component: Index,
    },
    {
        path: "/download",
        component: Download,
    },
    {path: "/:pathMatch(.*)*", redirect: "/"},
];

const router = createRouter({
    history: createWebHistory("/PNSCA"),
    routes,
});
createApp(App).use(router).use(ElementPlus).provide('$axios', axios).mount("#app");
